module.exports = __webpack_public_path__ + "static/media/no-forms.510affb3.png";